import React from "react";
import { useDispatch } from "react-redux";
import { prefOptionsSlice } from "redux/slices/prefOptionsSlice";
import { _t } from "app/i18n/i18n";
import { AppPreference } from "./AppSettings";
import { IconButtons } from "./IconButtons";
import { PreferenceTags } from "../PreferenceTags";
import usePreferences from "./usePreferences";

export function ResearchInterests({ handleClick }) {
  const { preferences, options, activeOption } = usePreferences();
  const [languagePreference] = options;
  const dispatch = useDispatch();

  return (
    <>
      <h3 className="font-weight-lighter">{_t("App Language")}</h3>
      <AppPreference preference={languagePreference} handleClick={handleClick} preferences={preferences} />

      <h3 className="font-weight-lighter">{_t("What are your interests?")}</h3>
      <p>
        {_t(
          "Please select your interests below. We'll use them to filter the latest reports and make recommendations.",
        )}
      </p>

      <IconButtons
        options={options}
        activeOption={activeOption}
        onClick={(selectedOption) => dispatch(prefOptionsSlice.actions.setActiveOption(selectedOption))}
      />

      <hr />

      <PreferenceTags preference={activeOption} selected={preferences[activeOption.id]} handleClick={handleClick} />
    </>
  );
}
